/*eslint-disable */
var $ = window.jQuery = require('jquery');
import {
mapGetters,
} from 'vuex';
export default {
name: 'user-spend-time-log',
components: {
},
props: [],
data () {
  return {
    allUserLogList:null,
    allUserLogListResults:[]
  }
},
computed: {
  ...mapGetters([
    'getAllUserOnlineTimeCountGetters',
  ]),
  getAllUserLogInfo(){
    this.allUserLogList = this.$store.getters.getAllUserOnlineTimeCountGetters;
    return;
  },
  setIntialStateAllUser(){
    if(this.allUserLogList){
      this.allUserLogListResults =  this.allUserLogList.data
    }
    return;
  },
},
mounted () {
  this.getAllUserLogInfo
  this.setIntialStateAllUser
},
methods: {
  secondsToHms(d) {
      d = Number(d);
      var h = Math.floor(d / 3600);
      var m = Math.floor(d % 3600 / 60);
      var s = Math.floor(d % 3600 % 60);

      var hDisplay = h > 0 ? h + (h == 1 ? " Hour, " : " Hours, ") : "";
      var mDisplay = m > 0 ? m + (m == 1 ? " Min, " : " Mins, ") : "";
      var mODisplay = m > 0 ? m + (m == 1 ? " Min " : " Mins ") : "";
      var sDisplay = s > 0 ? s + (s == 1 ? " Sec" : " Secs") : "";
    if(hDisplay){
      return hDisplay + mODisplay; 
    }else{
      return mDisplay + sDisplay; 
    }
  },
},
watch: {
  getAllUserLogInfo(){
    return this.$store.getters.getAllUserOnlineTimeCountGetters
  },
  setIntialStateAllUser(){
    if(this.allUserLogList){
      this.allUserLogListResults =  this.allUserLogList.data
    }
    return;
  },
},
}